import React from "react";
import { Text } from "basis";
import {
  MONTHLY_FEES,
  FEES,
  RATES,
} from "../../../../components/Promotions/Description/constants";

export const Fallback = ({ au, nz }) => {
  
  const AU = () => (
    <>
      <Text align="center" margin="3 0">
        Monthly payments must be made during the promotional period. Paying only
        the minimum monthly payment will not pay out the purchase before the end
        of the plan. At the end of the plan, interest will be charged at{" "}
        {RATES["GEM_VISA_AU"]}% p.a. Monthly service fee of $
        {MONTHLY_FEES["AUD"]} per month applies. 
      </Text>
      <Text align="center" margin="3 0">
        New customers must apply &amp; be approved for a Latitude Gem Visa credit card.
      </Text>
    </>
  );

  const NZ = () => (
    <>
      <Text textStyle="body2" margin="0 0 3" align="center">
        Lending criteria, T&C's and fees apply, including a Gem Visa ${FEES["ESTABLISHMENT"]} establishment fee and ${FEES["GEM_VISA"]} annual fees (${FEES["GEM_VISA_HALF_YEARLY"]} half yearly). Interest (currently {RATES["GEM_VISA_NZ"]}% p.a.) applies after any interest free plan expires. Credit provided by Latitude Financial Services Limited.
      </Text>
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};
